import React from 'react';
import { connect } from 'react-redux';
import BaseComponent from '../../baseClasses/BaseComponent';
import closeoutsService from '../../services/closeoutsService';
import dataModel from '../../models/DataModel';
import AnalyticsLogger from '../../helpers/analytics/analyticsLogger';
import LocationsIconSolid from '../Iconoclast/LocationsIconSolid';
import ReduxConstants from '../../constants/ReduxConstants';
import projectTemplatesService from '../../services/projectTemplatesService';
import PopupMenu from '../../components/PopupMenu';

import './PDFGenerator.scss';

export class PDFGenerator extends BaseComponent {
  constructor(props) {
    super(props);

    this.stateTree = {
      project: {},
      pdf: {
        currentPage: 1,
      },
    };

    this.promptCloseoutPrint = this.promptCloseoutPrint.bind(this);
    this.popupTemplateMenu = this.popupTemplateMenu.bind(this);
    this.handleCloseMenu = this.handleCloseMenu.bind(this);
    this.handleTemplateSelection = this.handleTemplateSelection.bind(this);
    this.handleCloseoutInProgress = this.handleCloseoutInProgress.bind(this);
    this.getLevel = this.getLevel.bind(this);
  }

  componentDidMount() {
    
    const currentRole = this.props.currentUser ? this.props.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });

    if (!this.props.closeout_templates) {
      projectTemplatesService.getProjectTemplateCloseouts().then(closeout_templates => {
        this.setState({ closeout_templates });
      });
    }
    else if (this.props.closeout_templates != 'wait') {
      this.setState({ closeout_templates: this.props.closeout_templates });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.closeout_templates != this.props.closeout_templates && this.props.closeout_templates != 'wait') {
      this.setState({ closeout_templates: this.props.closeout_templates });
    }
  }

  popupTemplateMenu(e) {
    e.stopPropagation();
    this.setState({ displayTemplateMenu: true });
  }

  // TODO: pass in closeoutable and closeoutableType as props instead of project
  getCloseoutableAndType() {
    const { project, build, task, closeout_client_data, handleCloseoutGenerated } = this.props;
    // generate project closeout by default
    let closeoutableType = 'project';
    let closeoutable = project;
    if (task) {
      // in task view, generate task closeout
      closeoutableType = 'task';
      closeoutable = task;
    }
    else if (build && build.ancestry) {
      // in builds view, generate build closeout
      closeoutableType = 'build';
      closeoutable = build;
    }
    else if (project) {
      closeoutableType = 'project';
      closeoutable = project;
    }
    if (!handleCloseoutGenerated) {
      this.logCloseoutTemplate(project.project_template ? project.project_template.id : null, closeoutableType);
    } else {
      handleCloseoutGenerated();
    }
    return {
      closeoutableType,
      closeoutable,
      closeout_client_data,
    };
  }

  logCloseoutTemplate(projectTemplateId, type) {
    this.analyticsLogger.closeoutType = type;
    if (projectTemplateId) {
      dataModel.projectTemplatesDAO.getProjectTemplate(projectTemplateId).then(template => {
        this.analyticsLogger.logCloseoutDocumentEvent(template);
      });
    }
    else this.analyticsLogger.logCloseoutDocumentEvent();
  }

  generateCloseout(closeoutableType, closeoutable, client_data) {
    if (this.props.closeoutStarted) {
      this.props.closeoutStarted();
    }
    // make a call to generate the closeout
    closeoutsService.createCloseout({
      closeoutable_type: closeoutableType,
      closeoutable_id: closeoutable.id,
      company_closeout_template_id: this.template.id,
      client_data,
    }).then(response => {
      if (response.error) {
        if (response.error.response.status == 409) {
          this.handleCloseoutInProgress();
        }
        if (response.error.response.status == 422) {
          var data = response.error.response.data;
          if(data && data.hasOwnProperty('message')){
            if(data.message && data.message.hasOwnProperty('location')){
              dataModel.displayHTTPError('Error generating the closeout', 'location doesn\'t exist for project', false);
            } else {
              dataModel.displayHTTPError('Error generating the closeout', response.error, false);
            }
          } else {
            dataModel.displayHTTPError('Error generating the closeout', response.error, false);
          }
        }
      }
    }).catch(error => {
      dataModel.displayHTTPError('Error generating the closeout', error, false);
    });
  }

  handleCloseoutInProgress() {
    let message = <span>A Closeout Package is already in progress for this item. When the Closeout Package is complete, you will be able to access it on the Project Closeout tab.</span>;
    dataModel.showGlobalModal('SYSTEM_POPUP', {
      captionText: 'ATTENTION',
      type: 'info',
      message: message,
      cancelButtonText: this.textMap.cancel,
      okButtonText: 'OK',
      okButtonColor: 'green',
      width: 320,
      height: 200,
      handleOwnerOk: () => {
      },
    });
  }

  getLevel(){
    const {  closeoutableType } = this.getCloseoutableAndType();
    switch(closeoutableType){
    case 'build':
      return ' Build Level ';
    case 'task':
      return ' Task Level ';
    default:
      return ' Project Level ';
    }
  }

  promptCloseoutPrint(template) {
    this.template = template;
    const { closeout_client_data } = this.props;

    let message;
    if (closeout_client_data && closeout_client_data.destination == ReduxConstants.CLOSEOUT_SUMMARY) {
      message = <span>A Closeout Package will be generated. When your Closeout Package is complete, you will receive a notification and be able to access it on the Project Closeout tab.</span>;
    } else {
      message = <span>A {this.getLevel()} Closeout Package will be generated. When your Closeout Package is complete, you will receive a notification and be able to access it from the Plan of Record. <LocationsIconSolid/> </span>;
    }
    dataModel.showGlobalModal('SYSTEM_POPUP', {
      captionText: 'ATTENTION',
      type: 'info',
      message: message,
      cancelButtonText: this.textMap.cancel,
      okButtonText: 'OK',
      okButtonColor: 'green',
      width: 320,
      height: 200,
      handleOwnerOk: () => {
        const { closeoutable, closeoutableType, closeout_client_data } = this.getCloseoutableAndType();
        this.generateCloseout(closeoutableType, closeoutable, closeout_client_data);
      },
    });
  }

  handleTemplateSelection(option) {
    const company_closeout_template_id = +option;
    const template = this.state.closeout_templates.find(t => {return t.id == company_closeout_template_id;});
    this.promptCloseoutPrint(template);
    this.handleCloseMenu();
  }

  handleCloseMenu() {
    this.setState({ displayTemplateMenu: false });
  }

  render() {
    const { height, text, icon } = this.props;

    let style = {
      height,
    };

    let templateMenu = null;
    if (this.state.displayTemplateMenu && this.state.closeout_templates) {
      // remove all closeout templates except PDF (id: 1)
      // the templates are in company_closeout_templates table
      const pdfCloseoutTemplate = this.state.closeout_templates.filter(template => template.id === 1);
      const menuOptions = pdfCloseoutTemplate.map(template => {
        return { type: template.id, name: template.name == 'Standard' ? 'Generate Closeout Report' : template.name, dismiss: true };
      });
      templateMenu = <PopupMenu right={this.props.fromProjectSummary ? 1 : 36} top={this.props.fromProjectSummary ? 60 : 33} width={220} menuOptions={menuOptions} size="small" noBackground={false}
      menuId="templateMenu" handleClickAway={this.handleCloseMenu} handleMenuSelection={this.handleTemplateSelection} />;
    }
    return (
      <div className={this.props.class}>
        {templateMenu}
        <div className="export" style={style} onClick={this.popupTemplateMenu}>
          { this.props.children }
          {text}
          {icon}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentUser: state.new_users.currentUser,
  };
};

export default connect(mapStateToProps)(PDFGenerator);



// WEBPACK FOOTER //
// ./src/components/PDFGenerator/index.js